"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
const DeedType_1 = __importDefault(require("./DeedType"));
const OfficeFolder_1 = __importDefault(require("./OfficeFolder"));
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
const DocumentType_1 = __importDefault(require("./DocumentType"));
class Deed extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = Deed;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Deed.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => DeedType_1.default),
    __metadata("design:type", DeedType_1.default)
], Deed.prototype, "deed_type", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Deed.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Deed.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => DocumentType_1.default),
    __metadata("design:type", Array)
], Deed.prototype, "document_types", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => OfficeFolder_1.default),
    __metadata("design:type", OfficeFolder_1.default)
], Deed.prototype, "office_folder", void 0);
